'use strict';
import { forEach, map, join } from 'lodash';
import { appendQueryParams } from '../utils';

export default (API) => ({
    appointments: {
        advancedSearch: (searchParams) => {
            let url = `v3/establishments/${searchParams.establishment}/appointments/search`;
            url += `?dateStart=${searchParams.dateStart}`;
            url += `&dateStop=${searchParams.dateStop}`;
            url += `&itemsPerPage=${searchParams.itemsPerPage}`;
            url += `&page=${searchParams.page}`;
            url += `&timezone=${searchParams.timezone}`;
            url += `&${join(map(searchParams.visibleColumns, c => 'visibleColumns[]=' + c), '&')}`;
            url += searchParams.hour ? `&hour=${searchParams.hour}` : '';
            url += searchParams.name ? `&name=${searchParams.name}` : '';
            url += searchParams.services[0] ? `&services=${searchParams.services.join(',')}` : '';
            url += searchParams.places[0] ? `&places=${searchParams.places.join(',')}` : '';
            url += searchParams.resources[0] ? `&resources=${searchParams.resources.join(',')}` : '';
            url += searchParams.appointmentNumber ? `&appointmentNumber=${searchParams.appointmentNumber}` : '';
            url += searchParams.statuses[0] ? `&statuses=${searchParams.statuses}` : '';
            url += searchParams.clientStatuses[0] || searchParams.clientStatuses[0] === 0 ? `&clientStatuses=${searchParams.clientStatuses.join(',')}` : '';
            url += searchParams.email ? `&email=${searchParams.email}` : '';
            url += searchParams.phone ? `&phone=${searchParams.phone}` : '';
            url += searchParams.cellphone ? `&cellphone=${searchParams.cellphone}` : '';
            url += searchParams.birthDate ? `&birthDate=${searchParams.birthDate}` : '';
            url += searchParams.nam ? `&nam=${searchParams.nam}` : '';
            url += searchParams.comments ? `&comments=${searchParams.comments}` : '';
            url += searchParams.source ? `&source=${searchParams.source}` : '';
            url += searchParams.orderBy ? `&orderBy=${searchParams.orderBy}` : '';

            const request = API.http.get(url);
            return API.handleError(request);
        },

        globalAppointmentSearch: (searchParams) => {
            let url = `/v3/appointments/globalAppointmentSearch`;
            url += `?itemsPerPage=${searchParams.itemsPerPage}`;
            url += `&page=${searchParams.page}`;
            url += `&timezone=${searchParams.timezone}`;
            url += `&${join(map(searchParams.visibleColumns, c => 'visibleColumns[]=' + c), '&')}`;
            url += searchParams.name ? `&name=${searchParams.name}` : '';
            url += searchParams.appointmentNumber ? `&appointmentNumber=${searchParams.appointmentNumber}` : '';
            url += searchParams.email ? `&email=${searchParams.email}` : '';
            url += searchParams.phone ? `&phoneOrCellphone=${searchParams.phone}` : '';
            url += searchParams.birthDate ? `&birthDate=${searchParams.birthDate}` : '';
            url += searchParams.nam ? `&nam=${searchParams.nam}` : '';
            url += searchParams.statuses[0] ? `&statuses=${searchParams.statuses}` : '';
            url += searchParams.clientStatuses[0] || searchParams.clientStatuses[0] === 0 ? `&clientStatuses=${searchParams.clientStatuses.join(',')}` : '';
            const request = API.http.get(url);
            return API.handleError(request);
        },

        globalSearch: (searchParams) => {
            let url = `v3/establishments/${searchParams.establishment}/appointments/globalAppointmentSearch`;
            url += `?itemsPerPage=${searchParams.itemsPerPage}`;
            url += `&page=${searchParams.page}`;
            url += `&timezone=${searchParams.timezone}`;
            url += `&${join(map(searchParams.visibleColumns, c => 'visibleColumns[]=' + c), '&')}`;
            url += searchParams.name ? `&name=${searchParams.name}` : '';
            url += searchParams.services[0] ? `&services=${searchParams.services.join(',')}` : '';
            url += searchParams.appointmentNumber ? `&appointmentNumber=${searchParams.appointmentNumber}` : '';
            url += searchParams.statuses[0] ? `&statuses=${searchParams.statuses}` : '';
            url += searchParams.clientStatuses[0] || searchParams.clientStatuses[0] === 0 ? `&clientStatuses=${searchParams.clientStatuses.join(',')}` : '';
            url += searchParams.email ? `&email=${searchParams.email}` : '';
            url += searchParams.phone ? `&phoneOrCellphone=${searchParams.phone}` : '';
            url += searchParams.birthDate ? `&birthDate=${searchParams.birthDate}` : '';
            url += searchParams.nam ? `&nam=${searchParams.nam}` : '';

            const request = API.http.get(url);
            return API.handleError(request);
        },

        exportFile: (searchParams, exportMethod, reportType, timeout = 20000) => {
            let page = exportMethod === 'pdf'
                ? 'generatePdfFile'
                : 'generateExcelFile';
            let url = `v3/establishments/${searchParams.establishment}/` + page;
            url += `?dateStart=${searchParams.dateStart}`;
            url += `&dateStop=${searchParams.dateStop}`;
            url += `&timezone=${searchParams.timezone}`;
            url += searchParams.hour ? `&hour=${searchParams.hour}` : '';
            url += searchParams.name ? `&name=${searchParams.name}` : '';
            url += searchParams.services[0] ? `&services=${searchParams.services.join(',')}` : '';
            url += searchParams.places[0] ? `&places=${searchParams.places.join(',')}` : '';
            url += searchParams.resources[0] ? `&resources=${searchParams.resources.join(',')}` : '';
            url += searchParams.appointmentNumber ? `&appointmentNumber=${searchParams.appointmentNumber}` : '';
            url += searchParams.statuses[0] ? `&statuses=${searchParams.statuses}` : '';
            url += searchParams.clientStatuses[0] || searchParams.clientStatuses[0] === 0 ? `&clientStatuses=${searchParams.clientStatuses.join(',')}` : '';
            url += searchParams.email ? `&email=${searchParams.email}` : '';
            url += searchParams.phone ? `&phone=${searchParams.phone}` : '';
            url += searchParams.cellphone ? `&cellphone=${searchParams.cellphone}` : '';
            url += searchParams.birthDate ? `&birthDate=${searchParams.birthDate}` : '';
            url += searchParams.nam ? `&nam=${searchParams.nam}` : '';
            url += searchParams.comments ? `&comments=${searchParams.comments}` : '';
            url += searchParams.source ? `&source=${searchParams.source}` : '';
            url += searchParams.locale ? `&locale=${searchParams.locale}` : '';
            url += searchParams.orderBy ? `&orderBy=${searchParams.orderBy}` : '';
            url += reportType ? `&reportType=${reportType}` : '';
            url += `&${join(map(searchParams.visibleColumns, c => 'visibleColumns[]=' + c), '&')}`;
            const request = API.http.get(url, { timeout });
            return API.handleError(request);
        },

        declarePrintListOperation: (searchParams) => {
            const url = `v3/establishments/${searchParams.establishment}/declarePrintOperation?type=appointment_list_print`;

            const body = {
                dateStart: searchParams.dateStart,
                dateStop: searchParams.dateStop,
                timezone: searchParams.timezone,
                ...(searchParams.hour && { hour: searchParams.hour }),
                ...(searchParams.name && { name: searchParams.name }),
                ...(searchParams.services[0] && { services: searchParams.services.join(',') }),
                ...(searchParams.places[0] && { places: searchParams.places.join(',') }),
                ...(searchParams.resources[0] && { resources: searchParams.resources.join(',') }),
                ...(searchParams.appointmentNumber && { appointmentNumber: searchParams.appointmentNumber }),
                ...(searchParams.statuses[0] && { statuses: searchParams.statuses.join(',') }),
                ...(searchParams.clientStatuses[0] || searchParams.clientStatuses[0] === 0 ? { clientStatuses: searchParams.clientStatuses.join(',') } : {}),
                ...(searchParams.email && { email: searchParams.email }),
                ...(searchParams.phone && { phone: searchParams.phone }),
                ...(searchParams.cellphone && { cellphone: searchParams.cellphone }),
                ...(searchParams.birthDate && { birthDate: searchParams.birthDate }),
                ...(searchParams.nam && { nam: searchParams.nam }),
                ...(searchParams.comments && { comments: searchParams.comments }),
                ...(searchParams.source && { source: searchParams.source }),
                ...(searchParams.locale && { locale: searchParams.locale }),
            };

            // Make a POST request with the body
            const request = API.http.post(url, body); // Assuming `post` method accepts (url, body)
            return API.handleError(request);
        },

        declarePrintLabelOperation: (establishmentId, body) => {
            const url = `v3/establishments/${establishmentId}/declarePrintOperation?type=appointment_label_print`;
            const request = API.http.post(url, body);
            return API.handleError(request);
        },
        get: (establishmentId, appointmentId, view) => {
            let url = 'v3/establishments/' + establishmentId + '/appointments/' + appointmentId;
            if (view) url += `?view=${view}`;

            const request = API.http.get(url);
            return API.handleError(request);
        },
        getGroupOfAppointment: (establishmentId, appointmentNumber, appointmentDate, uuid, recaptchaToken) => {
            let url = 'v3/establishments/' + establishmentId + '/appointments/' + appointmentNumber + '/group';
            let params = { uuid: !!uuid, recaptchaToken: recaptchaToken, date: appointmentDate };
            url = appendQueryParams(url, params);

            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAll(establishmentId, dateStart, dateStop, places = null, services = null, resources = null, timezone = null, view = null) {
            let url = `v3/establishments/${establishmentId}/appointments?dateStart=${dateStart}&dateStop=${dateStop}` +
            (places ? `&places=${places.join(',')}` : '') +
            (services ? `&services=${services.join(',')}` : '') +
            (resources ? `&resources=${resources.join(',')}` : '') +
            (timezone ? `&timezone=${timezone}` : '') +
            (view ? `&view=${view}` : '');
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAppointmentMessagesHistory(establishmentId, appointmentId) {
            const url = `/v3/establishments/${establishmentId}/appointments/${appointmentId}/history`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllForPlace(establishmentId, place, dateStart, dateStop, timezone) {
            const url = `v3/establishments/${establishmentId}/appointments?dateStart=${dateStart}&dateStop=${dateStop}&places=${place}&timezone=${timezone}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        create(establishmentId, payload) {
            const url = 'v3/establishments/' + establishmentId + '/appointments';
            const params = new FormData();
            forEach(payload, (val, key) => {
                params.append(key, val);
            });
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 30000 });
            return API.handleError(request);
        },
        update(establishmentId, appointmentId, params) {
            const url = 'v3/establishments/' + establishmentId + '/appointments/' + appointmentId;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateStates(establishmentId, params) {
            const url = 'v3/establishments/' + establishmentId + '/appointments/states';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateState(establishmentId, appointmentId, params) {
            const url = 'v3/establishments/' + establishmentId + '/appointments/' + appointmentId + '/state';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateClientState(establishmentId, appointmentId, params) {
            const url = 'v3/establishments/' + establishmentId + '/appointments/' + appointmentId + '/state/client';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        getReport(dateStart, dateStop, establishments, timezone) {
            let url = `v3/appointments/report?dateStart=${dateStart}&dateStop=${dateStop}&timezone=${timezone}`;
            if (establishments) {
                url += `&establishments=${establishments}`;
            }
            const request = API.http.get(url);
            return API.handleError(request);
        },
        sendMessage(establishmentId, appointmentId, messageType, configurationMessage) {
            const url = `v3/establishments/${establishmentId}/appointments/${appointmentId}/message/${messageType}/${configurationMessage}`;
            const request = API.http.post(url);
            return API.handleError(request);
        },
        sendMail(establishmentId, params) {
            const url = 'v3/establishments/' + establishmentId + '/appointments/mails';
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        sendSMS(establishmentId, params) {
            const url = 'v3/establishments/' + establishmentId + '/appointments/sms';
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        fetchScannedRequest(appointmentId) {
            const url = 'v3/appointments/' + appointmentId + '/scannedRequest';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        appointmentsReport(establishmentId, params) {
            const url = `v3/establishments/${establishmentId}/appointments/report`;
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        appointmentInfoFromJobId(jobId) {
            let url = `v3/appointments/jobs/${jobId}/appt-data`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        jobControlInformation(jobId) {
            let url = `v3/appointments/jobs/${jobId}/control`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
    },
});
